import { Line } from "./styles";
import { dateFormat } from "utils/dateFormat"
import CustomCheckBox from "components/checkbox";
import CircularProgress from '@mui/material/CircularProgress';
import { defaultTheme } from "styles/theme/default";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ExportRoutesResponse, IOrderRoute } from "interfaces/IWaybill";
import { IAgileRoute } from "interfaces/IAgileRouteResponse";

interface IFormTableLine {
  element: IAgileRoute;
  handleToggleSelected: (routeId: number) => void;
  selectedRows: number[];
  waitingCarambola: boolean;
  waitingMaracuja: boolean;
  responsesCarambola: ExportRoutesResponse | null;
  responsesMaracuja: ExportRoutesResponse | null;
  dataOrderRoute: IOrderRoute[] | null;
  maracujaRouteCounts: Record<number, number>;
}


export const FormTableLine = ({
  element,
  handleToggleSelected,
  selectedRows,
  waitingCarambola,
  waitingMaracuja,
  responsesCarambola,
  responsesMaracuja,
  dataOrderRoute,
  maracujaRouteCounts,
}: IFormTableLine) => {

  const handleChecked = () => selectedRows.includes(element.routeId);

  const getResultIcon = (statusCode: number) => {
    return statusCode === 200
      ? <CheckIcon sx={{ color: defaultTheme.colors.base, fontSize: 18 }} />
      : <CloseIcon sx={{ color: defaultTheme.colors.danger, fontSize: 18 }} />;
  };

  const carambolaCount = dataOrderRoute?.filter(({ route }: IOrderRoute) => route === element?.routeId)?.length ?? 0;

  const maracujaCount = maracujaRouteCounts[element.routeId];

  const isSelected = handleChecked();
  const totalOrders = element.routeDetails?.length ?? 0;

  const carambolaStatus = responsesCarambola?.[element.routeId];
  const maracujaStatus = responsesMaracuja?.[element.routeId];

  return (
    <Line className="bodyLine">
      <td>
        <CustomCheckBox
          handleToggle={() => handleToggleSelected(element.routeId)}
          checked={isSelected}
          align='center'
        />
      </td>
      <td align="left" className='contentTable'>
        <span>{element?.vehicle?.driver?.name}</span>
      </td>
      <td align="center">
        <span className="routes">{element.routeId}</span>
      </td>
      <td align="center">
        <span className="routes">{element.depot?.depotName}</span>
      </td>
      <td align="center">
        <span className="date">{dateFormat(element.executionDate)}</span>
      </td>
      <td align="center">
        <span className="routes">{carambolaCount} / {totalOrders}</span>
      </td>
      <td align="center">
        <span className="routes">
          {maracujaCount !== undefined ? `${maracujaCount} / ${totalOrders}` : "—"}
        </span>
      </td>
      <td align="center">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
          {waitingCarambola && isSelected && carambolaStatus === undefined ? (
            <CircularProgress size={14} sx={{ color: defaultTheme.colors.base }} thickness={6} />
          ) : carambolaStatus !== undefined ? (
            getResultIcon(carambolaStatus)
          ) : null}
          {waitingMaracuja && isSelected && maracujaStatus === undefined ? (
            <CircularProgress size={14} sx={{ color: defaultTheme.colors.base }} thickness={6} />
          ) : maracujaStatus !== undefined ? (
            getResultIcon(maracujaStatus)
          ) : null}
        </div>
      </td>
    </Line>
  );
};
